<template>
  <div class="setting-component">
    <!-- [ Menu ] end -->
    <div class="wrap">
      <div class="wrap__tree">
        <div class="nav-tree">
          <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain
                     icon="el-icon-plus">Add Xero Item
          </el-button>
        </div>
        <el-table
            max-height="650"
            :data="tableData"
            style="width: 100%"
            :empty-text="$t('general_noData')">
          <el-table-column
              label="ID"
              type="index"
              width="50">
          </el-table-column>
          <el-table-column
              label="Code"
              prop="Code"
              width="100">
          </el-table-column>
          <el-table-column
              label="Name"
              prop="Name">
          </el-table-column>
          <el-table-column
              label="Description"
              prop="Description">
          </el-table-column>
          <el-table-column
              label="Update Date"
              width="200">
            <template slot-scope="scope">
              {{ formatDate(scope.row.UpdatedDateUTC) }}
            </template>
          </el-table-column>
          <el-table-column
              width="120"
              :label="$t('settings_accountThink_itemsTypes_operations')">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  @click="handleUpdate(scope.row)"></el-button>
              <el-button
                  size="mini"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <sweet-modal blocking :title="`${ItemID ? 'Update' : 'Add'}  Xero Item`" ref="openModal" class="modal" v-on:close="closeModal" width="700">
      <el-form :model="form" ref="form" status-icon :rules="rules" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item prop="code">
              <el-input label="Code" size="small" v-model="form.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item prop="name">
              <el-input label="Name" size="small" v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-checkbox
            name="trackInventory"
            size="small"
            v-model="form.trackInventory"
            @change="toggleTrackInventory">
          <h3>Track inventory item</h3>
        </el-checkbox>
        <div>
          Track the quantity and value of stock on hand. This option is suitable for organisations with less then 4,000
          products or services, who purchase items before they are sold, who purchase items before they are sold, and
          who calculate the average cost of items.
        </div>
        <el-card v-if="form.trackInventory" style="margin-top: 10px;">
          <div>
            Items can't be untracked once they appear on transaction. This includes the opening balance, an adjustment,
            or a bill or an invoice
          </div>
        </el-card>
        <el-form-item v-if="form.trackInventory" prop="inventoryAssetAccountCode" style="margin-top: 10px;">
          <el-select
              class="select"
              placeholder="Inventory Asset account"
              size="mini"
              v-model="form.inventoryAssetAccountCode"
          >
            <el-option
                v-for="item in assetAccountList"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-checkbox
            name="isPurchase"
            size="small"
            :disabled="form.trackInventory"
            v-model="form.isPurchase">
          <h3>Purchase</h3>
        </el-checkbox>
        <div>
          Add item to bills, purchase orders, and other purchase transactions
        </div>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8" :offset="0">
            <el-form-item prop="purchasePrice">
              <el-input label="Cost price" size="small" v-model="form.purchasePrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="purchaseAccountId">
              <el-select
                  style="width: 100%"
                  class="select"
                  placeholder="Purchase account"
                  size="mini"
                  v-model="form.purchaseAccountId"
              >
                <el-option
                    v-for="item in accountList"
                    :key="item.Code"
                    :label="item.Name"
                    :value="item.Code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="purchaseTax">
              <el-select
                  style="width: 100%"
                  class="select"
                  placeholder="Tax rate"
                  size="mini"
                  v-model="form.purchaseTax"
              >
                <el-option
                    v-for="item in taxList"
                    :key="item.TaxType"
                    :label="item.Name"
                    :value="item.TaxType">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="clear: both;" label="Description" prop="purchasesDescription">
          <el-input
              type="textarea"
              :rows="2"
              v-model="form.purchasesDescription">
          </el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-checkbox
            name="isPurchase"
            size="small"
            :disabled="form.trackInventory"
            v-model="form.isSell">
          <h3>Sell</h3>
        </el-checkbox>
        <div>
          Add item to invoices, quotes, and other sales transactions
        </div>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8" :offset="0">
            <el-form-item prop="salesPrice">
              <el-input label="Sale price" size="small" v-model="form.salesPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="salesAccountId">
              <el-select
                  style="width: 100%"
                  class="select"
                  placeholder="Sales account"
                  size="mini"
                  v-model="form.salesAccountId"
              >
                <el-option
                    v-for="item in accountList"
                    :key="item.Code"
                    :label="item.Name"
                    :value="item.Code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="salesTax">
              <el-select
                  style="width: 100%"
                  class="select"
                  placeholder="Tax rate"
                  size="mini"
                  v-model="form.salesTax"
              >
                <el-option
                    v-for="item in taxList"
                    :key="item.TaxType"
                    :label="item.Name"
                    :value="item.TaxType">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="clear: both;" label="Description" prop="salesDescription">
          <el-input
              type="textarea"
              :rows="2"
              v-model="form.salesDescription">
          </el-input>
        </el-form-item>
        <el-divider></el-divider>
        <!--        <el-form-item style="clear: both;" label="Description" prop="description">-->
        <!--          <el-input-->
        <!--              type="textarea"-->
        <!--              :rows="2"-->
        <!--              v-model="form.description">-->
        <!--          </el-input>-->
        <!--        </el-form-item>-->
        <el-form-item class="modal__btn">
          <el-button @click="ItemID ? handleEdit ('form') : addItem('form')" type="primary">{{ ItemID ? 'Update' : $t('general_submit') }}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

function formatDate (dateString) {
  // Extract the timestamp from the input string
  const timestamp = parseInt(dateString.match(/\d+/)[0])

  // Create a new Date object using the timestamp
  const date = new Date(timestamp)

  // Get the day, month, and year components from the Date object
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are 0-based
  const year = date.getFullYear()

  // Combine the components to form the desired format (dd-mm-yyyy)
  const formattedDate = `${day}-${month}-${year}`

  return formattedDate
}

const acceptedTypes = ['EXPENSE', 'ASSET', 'LIABILITIES', 'EQUITY', 'REVENUE']
export default {
  name: 'itemXero',
  components: {
    SweetModal,
  },
  data () {
    const checkCode = (rule, value, callback) => {
      console.log('value === this.excludedCode', value, this.excludedCode)
      if (value && this.codesArray.includes(value) && value === this.excludedCode) {
        return callback()
      }
      if (value && this.codesArray.includes(value) && value !== this.excludedCode) {
        return callback(new Error('Code must be uniques'))
      } else callback()
    }
    return {
      tableData: [],
      form: {
        code: '',
        name: null,
        // description: '',
        inventoryAssetAccountCode: null,
        purchasePrice: null,
        purchaseTax: null,
        purchaseAccountId: null,
        purchasesDescription: '',
        salesPrice: null,
        salesTax: null,
        salesAccountId: null,
        salesDescription: '',
        // checkboxes
        trackInventory: false,
        isPurchase: false,
        isSell: false
      },

      rules: {
        code: [
          { required: true, message: 'Field is required', trigger: 'blur' },
          { validator: checkCode, trigger: 'blur' }
        ],
      },
      accountList: [],
      taxList: [],
      formatDate: formatDate,
      ItemID: null,
      assetAccountList: [],
      excludedCode: null
    }
  },
  computed: {
    codesArray () {
      return this.tableData.map(item => item.Code)
    }
  },
  methods: {
    async openModalAdd () {
      let loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
      this.$refs.openModal.open()
      try {
        const accounts = await axios.get(`/api/v1/xero/account/list?companyId=${this.$route.query.companyId}`)
        this.assetAccountList = accounts.data.list.filter(account => account.Type === 'INVENTORY')
        this.accountList = accounts.data.list.filter(item => {
          return acceptedTypes.includes(item.Type)
        })
        this.accountList.unshift({ Code: '', Name: 'None' })
        const taxes = await axios.get(`/api/v1/xero/taxRate/list?companyId=${this.$route.query.companyId}`)
        this.taxList = taxes.data.list
      } catch (err) {
        console.log('err', err)
      }
      loader.hide()
    },
    closeModal () {
      this.ItemID = null
      this.form.trackInventory = false
      this.form.isPurchase = false
      this.form.isSell = false
      this.excludedCode = null
      this.$refs['form'].resetFields()
    },
    loadList (state = 'xero') {
      let loader = this.$loading.show()
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
      axios
          .get(`/api/v1/xero/item/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error)
            loader.hide()
          })
    },
    toggleTrackInventory (val) {
      if (val) {
        this.form.isPurchase = true
        this.form.isSell = true
      }
    },
    addItem (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show()
          const payload = {
            code: this.form.code,
            name: this.form.name,
            // description: this.form.description,
            inventoryAssetAccountCode: this.form.inventoryAssetAccountCode,
            purchasePrice: this.form.purchasePrice,
            purchaseTax: this.form.purchaseTax,
            purchaseAccountId: this.form.purchaseAccountId,
            salesPrice: this.form.salesPrice,
            salesTax: this.form.salesTax,
            salesAccountId: this.form.salesAccountId,
            purchasesDescription: this.form.purchasesDescription,
            salesDescription: this.form.salesDescription
          }

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
          axios
              .post(`/api/v1/xero/item/create?companyId=${this.$route.query.companyId}`, payload)
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
                this.notification('Success', 'Xero Item Create', 'success')
                loader.hide()
              }).catch(err => {
            console.log(err)
            this.$refs.openModal.close()
            this.loadList()
            loader.hide()
          })
        }
      })
    },
    async handleUpdate (row) {
      this.ItemID = row.ItemID
      this.excludedCode = row.Code
      this.form.code = row.Code
      this.form.name = row.Name
      this.form.inventoryAssetAccountCode = row.InventoryAssetAccountCode
      this.form.purchasePrice = row.PurchaseDetails.UnitPrice
      this.form.purchaseTax = row.PurchaseDetails.TaxType
      this.form.purchaseAccountId = row.PurchaseDetails.COGSAccountCode
      this.form.salesPrice = row.SalesDetails.UnitPrice
      this.form.salesTax = row.SalesDetails.TaxType
      this.form.salesAccountId = row.SalesDetails.AccountCode
      this.form.purchasesDescription = ''
      this.form.salesDescription = ''
      this.form.trackInventory = row.IsTrackedAsInventory
      this.form.isPurchase = row.IsPurchased
      this.form.isSell = row.IsSold
      this.openModalAdd()
    },
    handleEdit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show()
          const payload = {
            code: this.form.code,
            name: this.form.name,
            inventoryAssetAccountCode: this.form.inventoryAssetAccountCode,
            purchasePrice: this.form.purchasePrice,
            purchaseTax: this.form.purchaseTax,
            purchaseAccountId: this.form.purchaseAccountId,
            salesPrice: this.form.salesPrice,
            salesTax: this.form.salesTax,
            salesAccountId: this.form.salesAccountId,
            purchasesDescription: this.form.purchasesDescription,
            salesDescription: this.form.salesDescription
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
          axios
              .post(`/api/v1/xero/item/update?companyId=${this.$route.query.companyId}&id=${this.ItemID}`, payload)
              .then(response => {
                loader.hide()
                this.loadList()
                this.notification('Success', 'Xero Item Updated', 'success')
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error)
              })
        }
      })

    },
    handleDelete (row) {
      this.$confirm('This will permanently delete the item. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios
            .get(`/api/v1/xero/item/delete?companyId=${this.$route.query.companyId}&id=${row.ItemID}`)
            .then(response => {
              loader.hide()
              this.loadList()
              this.notification('Success', 'Xero Item Delete', 'success')
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error)
            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    notification (title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      })
    },
  }
}
</script>

<style scoped>

</style>